import { NumberInput } from '@components/NumberInput';
import { Label } from '@components/styled/Label.styled';
import { BedIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/MaxOccupancyGroup.styled';
import { TitleGroup } from './TitleGroup';

export const MaxOccupancyGroup: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    return (
        <styled.MaxOccupancyGroup>
            <TitleGroup title="Max Occupancy" Icon={BedIcon} Chip={<Chip label="required" />} />
            <styled.Wrapper>
                <NumberInput disabled={disabled} name="maxOccupancy" />
                <Label>guests</Label>
            </styled.Wrapper>
        </styled.MaxOccupancyGroup>
    );
};
